import { format, parse } from 'date-fns';

export const monthLabelFormatter = (value: string) => {
  try {
    // Parse abbreviated month name ('Sep', 'Aug', etc.)
    const date = parse(value, 'MMM', new Date());

    // Format to full month name ('September', 'August', etc.)
    return format(date, 'MMMM');
  } catch {
    return value;
  }
};
